import { Hashtracking } from "@otto-ec/global-hashtracking";

window.o_global = window.o_global || {};
window.global = window.global || {};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.global.hashtracking = new Hashtracking();
window.o_global?.eventLoader.onLoad(100, () => {
  new Hashtracking().hashTrack();
});
